<template>
    <div>
        <SubNavigation :navigation="navigation" />

        <Notification v-if="! property">
            Loading...
        </Notification>

        <b-loading
            :is-full-page="true"
            :active="! property"
            :can-cancel="false"
        />

        <div v-if="property">
            <article class="media mb-5">
                <figure class="media-left">
                    <div class="image-wrapper">
                        <img
                            :src="`/contacts/vendor/properties/${property.PropertyPK}/photos/first?w=150`"
                            :alt="property.AddressString"
                        />
                    </div>
                </figure>
                <div class="media-content">
                    <div class="content">
                        <p class="title is-4">
                            {{ property.AddressString }}
                        </p>

                        <b-taglist attached>
                            <b-tag type="is-dark">
                                Status
                            </b-tag>
                            <b-tag>
                                {{ property.PropertyStatus }}
                            </b-tag>
                        </b-taglist>
                    </div>
                </div>
            </article>

            <hr />

            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from '../components/Notification.vue';
import SubNavigation from '../components/SubNavigation.vue';

export default {
    components: {
        Notification,
        SubNavigation,
    },

    data: function() {
        return {
            navigation: [
                {
                    label: 'Marketing',
                    name: 'sales-property',
                    visible: true,
                },
                {
                    label: 'Viewings',
                    name: 'sales-property-viewings',
                    visible: this.$meta.features.vendors.viewings,
                },
                {
                    label: 'Offers',
                    name: 'sales-property-offers',
                    visible: this.$meta.features.vendors.offers,
                },
                {
                    label: 'Statistics',
                    name: 'sales-property-statistics',
                    visible: this.$meta.features.vendors.statistics,
                },
            ],
        };
    },

    computed: {
        ...mapState('salesProperty', [
            'property',
        ]),
    },

    mounted() {
        this.getProperty();
    },

    methods: {
        getProperty() {
            this.$store.dispatch('salesProperty/getRow', this.$route.params.id)
            .then(() => {
                // redirect with message if property can't be found
                if(! this.property) {
                    this.$router.push({
                        name: 'sales-properties',
                        params: {
                            message: 'Invalid property.',
                        },
                    });
                }
            });
        },
    },
};
</script>
